/** Strings owned by `src/features/departments/` — WP-12's Departments
 * section in the normal app (§ Bedrijfscontext, § Zichtbaarheid). */
export const departments = {
  page: {
    title: 'Abteilungen',
    leadPersonal: 'Abteilungen, in denen du Mitglied bist.',
    leadCompany: 'Abteilungen bei {{company}}.',
  },
  list: {
    cardTitle: 'Abteilungen',
    name: 'Name',
    company: 'Unternehmen',
    statistics: 'Statistiken',
    collectiveConsent: 'Kollektive Einwilligung',
    inForce: 'gültig',
    none: '—',
    unattached: 'nicht zugeordnet',
    empty: 'Hier gibt es noch keine Abteilungen.',
    newDepartment: 'Neue Abteilung',
  },
  compare: {
    cardTitle: 'Vergleich der Abteilungen',
    pageTitle: 'Vergleich der Abteilungen',
    lead: 'Vergleich der Abteilungen, deren Statistiken du sehen darfst.',
    empty: 'Keine Abteilung hier hat Statistiken, die du sehen darfst.',
  },
  detail: {
    thisDepartment: 'Abteilung',
    edit: 'Bearbeiten',
    setVisibility: 'Sichtbarkeit festlegen',
    collectiveConsent: 'Kollektive Einwilligung',
    coach: 'Coach',
    category: 'Kategorie',
    type: 'Typ',
    statistics: 'Statistiken',
    notRecorded: 'nicht erfasst',
    membersCardTitle: 'Mitglieder',
    statsCardTitle: 'Statistiken',
    settingsCardTitle: 'Einstellungen',
    addPerson: 'Person hinzufügen',
    name: 'Name',
    nickname: 'Spitzname',
    login: 'Login',
    yes: 'ja',
    no: 'nein',
    noMembers: 'Keine Mitglieder.',
  },
  form: {
    newTitle: 'Neue Abteilung',
    newLead:
      'Jede neue Abteilung beginnt aggregate-only — der datenschutzfreundliche Zustand, den man durch Nichtstun erhält.',
    name: 'Name',
    category: 'Kategorie',
    type: 'Typ',
    cancel: 'Abbrechen',
    create: 'Abteilung erstellen',
    editTitle: 'Abteilung bearbeiten',
    save: 'Speichern',
    deleteCardTitle: 'Löschen',
    deleteButton: 'Diese Abteilung löschen',
    deleteConfirm: '{{name}} endgültig löschen?',
    deleteKeep: 'Behalten',
    deleteYes: 'Ja, löschen',
    visibilityTitle: 'Sichtbarkeit der Statistiken',
    visibilityLead:
      'individual legt für sich genommen niemanden offen: es erlaubt individuellen Zugriff, wo eine Einwilligungsbasis das Mitglied abdeckt. Der Wechsel zu individual ohne kollektiven Nachweis erzeugt für jedes aktuelle Mitglied eine offene Einwilligungsanfrage.',
    visibilityAggregate: 'aggregate — nur Gruppenzahlen',
    visibilityIndividual: 'individual — Zugriff pro Mitglied, wo Einwilligung vorliegt',
    collectiveConsentTitle: 'Kollektive Einwilligungsbasis',
    collectiveConsentLead:
      'Solange ein kollektiver Nachweis gültig ist, gilt er für jedes Mitglied von {{name}}, unabhängig von dessen persönlicher Antwort. Die eigenen Einträge der Mitglieder bleiben erhalten und gelten wieder, sobald er widerrufen wird.',
    collectiveConsentNote: 'Vereinbarung außerhalb der Plattform (genau benennen)',
    collectiveConsentRecord: 'Kollektive Basis erfassen',
    revokeCardTitle: 'Widerrufen',
    revokeButton: 'Kollektive Basis widerrufen',
  },
} as const;
